export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4661.1cf75094.jpg";